import React from 'react';
import { Backdrop, Grid } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useData } from '../../contexts';
import { MdClose } from 'react-icons/md';

export const InfoPanelCluster = (props: any) => {
  const { content, clusterAnalysePath } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { interfaceColor } = useData();

  const trimmedUrl = window.location.href.split('/').shift();
  const url = `${trimmedUrl}${clusterAnalysePath}/clusteranalyse`;

  return (
    <div
      className={'vl-typography'}
      style={{
        float: 'right',
        // marginLeft: 'auto',
        marginRight: '8px',
        cursor: 'pointer',
        paddingRight: '8px',
        paddingLeft: '8px',
        textDecoration: 'underline',
        color: interfaceColor,
        borderRadius: 12,
        position: 'relative',
        top: '18px',
      }}
    >
      <p onClick={handleOpen} style={{ marginBottom: 0 }}>
        Meer informatie
      </p>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        slots={{ backdrop: Backdrop, baseTooltip: null }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(255, 255, 255, 0,5)',
            },
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 1000,
            maxHeight: '90%',
            height: '90%',
            width: '90vw',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            overflowY: 'auto',
          }}
          className={'vl-typography'}
          id="selectionScreenBox"
        >
          <Grid container>
            <Grid item xs={12}>
              <h2 style={{ fontSize: 18, float: 'left' }}>Meer info</h2>

              <button
                onClick={handleClose}
                style={{
                  color: interfaceColor,
                  width: '30px',
                  float: 'right',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  marginLeft: '12px',
                  position: 'relative',
                  top: '0px',
                  right: '0px',
                  fontSize: '24px',
                  border: 'none',
                }}
              >
                <span className="vl-button__label">
                  <MdClose />
                </span>
              </button>
              <div style={{ clear: 'both' }}>
                {content === null && (
                  <>
                    <p>
                      Bij een clusteranalyse wordt een typologie van gemeenten
                      opgemaakt. Gemeenten met vergelijkbare kenmerken worden
                      ondergebracht in homogene klassen.{' '}
                    </p>
                    <br />
                    <p>
                      De doelstelling van deze clusteranalyse per thema is om
                      lokale besturen meer inzicht te geven in alle beschikbare
                      data, en om zo de eigen lokale context beter te kunnen
                      beschrijven en te analyseren. Daarnaast wordt het ook
                      mogelijk om meer inzicht te krijgen in deze context door
                      te vergelijken met andere gemeenten die eventueel een
                      gelijkaardige context kennen.{' '}
                    </p>
                    <br />
                    <p>
                      Wil je meer weten over deze clusteranalyse, onder andere
                      over de gehanteerde methodologie? Wil je nagaan welke
                      gemeenten binnen welke cluster vallen voor een bepaald
                      thema?{' '}
                      <a href={url} target="_blank">
                        Klik dan door naar de pagina Clusteranalyse
                      </a>
                      .
                    </p>
                  </>
                )}
                {content !== null && (
                  <>
                    {content}
                    <br />
                    <p>
                      Wil je meer weten over deze clusteranalyse, onder andere
                      over de gehanteerde methodologie? Wil je nagaan welke
                      gemeenten binnen welke cluster vallen voor een bepaald
                      thema?{' '}
                      <a href={url} target="_blank">
                        Klik dan door naar de pagina Clusteranalyse
                      </a>
                      .
                    </p>
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};
